export default class Payment {
  paymentType: string;
  paymentTotal: number;
  hostAddress: string;
}
